import axios from 'axios';
import eventBus from './event-bus';

axios.defaults.headers.get['Accepts'] = 'application/json';
axios.defaults.headers.get['Content-Type'] =
  'application/json, text/plain, */*';

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === 'production'
      ? window.location.origin + '/api'
      : 'http://localhost:5010/api',
  headers: {
    'Content-Type': 'application/json, text/plain, */*',
  },
});

instance.interceptors.request.use(
  (request) => request,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    } else {
      handleError(error);
    }

    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    } else {
      handleError(error);
    }

    return Promise.reject(error);
  }
);

instance.CancelToken = axios.CancelToken;

const handleError = function (error) {
  let message = error.response
    ? 'Произошла непредвиденная ошибка'
    : 'Ошибка сети';

  if (error.response) {
    switch (error.response.status) {
      case 404: {
        eventBus.emit('404', { message: error.response.data });

        return;
      }
      case 400: {
        return;
      }
      default:
        message = error.response.data || error.response.statusText;

        break;
    }
  }

  eventBus.emit('error', { message });
};

export default instance;
